import { Brightness4, Brightness7 } from '@mui/icons-material';
import { Box, Button, IconButton, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import useThemeContext from '../../../../themes/hooks/useThemeContext';
import Logo from '../../../common/Logo';
import FormContainer from '../../../common/sections/FormContainer';

interface LoginFormProps {
     onSubmit: (email: string, password: string) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSubmit }) => {
     const [email, setEmail] = useState('');
     const [password, setPassword] = useState('');
     const { theme, toggleTheme } = useThemeContext();

     const handleSubmit = (e: React.FormEvent) => {
          e.preventDefault();
          onSubmit(email, password);
     };

     // Seleciona o logo baseado no tema

     return (
          <FormContainer>
               <Box sx={{ alignSelf: 'center', mb: 2 }}>
                    <IconButton
                         onClick={toggleTheme}
                         sx={{
                              position: 'absolute',
                              top: 16,
                              right: 16,
                              color: theme.palette.text.primary,
                              '&:hover': {
                                   backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[200],
                              },
                         }}
                    >
                         {theme.palette.mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
                    </IconButton>
                    <Logo
                         alt='Logo IS Cantina'
                         width={120}
                         height={120}
                    />
               </Box>
               <Typography
                    variant='h5'
                    fontWeight={700}
                    align='center'
                    sx={{
                         mb: 1,
                         color: theme.palette.text.primary,
                    }}
               >
                    Bem-vindo(a) ao IS Cantina Client Web!
               </Typography>
               <Typography
                    variant='body2'
                    color='text.secondary'
                    align='center'
                    sx={{ mb: 3 }}
               >
                    Painel administrativo das cantinas escolares
               </Typography>
               <form
                    onSubmit={handleSubmit}
                    style={{ width: '100%' }}
               >
                    <Stack spacing={2}>
                         <TextField
                              label='E-mail'
                              type='email'
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                              fullWidth
                              sx={{
                                   '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                             borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[300],
                                        },
                                        '&:hover fieldset': {
                                             borderColor: theme.palette.primary.main,
                                        },
                                        '&.Mui-focused fieldset': {
                                             borderColor: theme.palette.primary.main,
                                        },
                                   },
                              }}
                         />
                         <TextField
                              label='Senha'
                              type='password'
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              required
                              fullWidth
                              sx={{
                                   '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                             borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[300],
                                        },
                                        '&:hover fieldset': {
                                             borderColor: theme.palette.primary.main,
                                        },
                                        '&.Mui-focused fieldset': {
                                             borderColor: theme.palette.primary.main,
                                        },
                                   },
                              }}
                         />
                         <Button
                              type='submit'
                              variant='contained'
                              color='primary'
                              fullWidth
                              sx={{
                                   py: 1.5,
                                   fontWeight: 600,
                                   backgroundColor: theme.palette.primary.main,
                                   '&:hover': {
                                        backgroundColor: theme.palette.primary.dark,
                                   },
                              }}
                         >
                              Entrar
                         </Button>
                         <Stack
                              direction='row'
                              justifyContent='space-between'
                              alignItems='center'
                         >
                              <Button
                                   component={RouterLink}
                                   to='/auth/reset-password'
                                   color='primary'
                                   sx={{
                                        color: theme.palette.primary.main,
                                        '&:hover': {
                                             backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.dark + '20' : theme.palette.primary.light + '20',
                                        },
                                   }}
                              >
                                   Esqueceu a senha?
                              </Button>
                         </Stack>
                    </Stack>
               </form>
          </FormContainer>
     );
};

export default LoginForm;
